import React from 'react';

import type { GridCellParams } from '@mui/x-data-grid-premium';
import { AlineAvatar, AlineAvatarGroup } from 'src/components/AlineAvatar';
import { AlineTooltip } from 'src/components/generic';
import type { ReminderListRow } from 'src/components/reminders/ColumnDef';

export function ReminderAssigneesCell({
  value: assignees = [],
}: GridCellParams<ReminderListRow, ReminderListRow['assignees']>): JSX.Element {
  if (!assignees.length)
    return (
      <AlineTooltip arrow placement="top" title="Unassigned">
        <AlineAvatar />
      </AlineTooltip>
    );

  return (
    <AlineAvatarGroup max={5}>
      {assignees.map(assignee => {
        return (
          <AlineTooltip key={assignee.id} arrow placement="top" title={assignee.displayName}>
            <AlineAvatar avatarInfo={assignee} />
          </AlineTooltip>
        );
      })}
    </AlineAvatarGroup>
  );
}
